<template>
  <div class="account-page">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <div class="main_home_content">
        <div class="container">
          <div class="row">
            <div
              class="col-md-10 offset-md-1 pt-1 pb-5"
              style="margin-top: 20px;"
            >
              <div class="home-content">
                <div class="row align-items-center justify-content-center">
                  <div class="col-md-7 col-lg-6">
                    <h2 class="right_heading">
                      Online Collaboration Tools for Interdisciplinary Care
                    </h2>
                    <h4 class="right_headline">
                      Empowering Healthcare Teams to Collaborate in Real-Time
                    </h4>
                    <h5 class="right_content">
                      {{ main_data }} Suite of Online Collaboration Tools
                      for Cohesive Patient Care
                    </h5>
                    <p class="right_content">
                      In today's complex healthcare landscape, interdisciplinary
                      collaboration is more crucial than ever. {{ main_data}}
                       Online Collaboration Tools are designed to
                      bridge the gaps between specialties, allowing healthcare
                      professionals to work together seamlessly and ensure that
                      patients receive well-rounded and comprehensive care.
                    </p>
                    <div style="margin-top: 50px;"></div>
                  </div>
                  <div class="col-md-12 col-lg-5">
                    <img style="height: 440px;"
                      src="@/assets/img/collaboration.jpeg"
                      class="img-fluid"
                      alt="Doccure Login"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div>
            <h3 style="text-align: center; margin-bottom: 40px;">
              Real-Time Communication Channels:
            </h3>
          </div>
        </div>

        <div>
          <div class="row mt-1">
            <div class="col-md-10 offset-md-1">
              <!-- <p><strong>Healthcare Practitioner Schedules:</strong></p> -->
              <b-card-group deck>
                <b-card
                  border-variant="dark"
                  header="Instantly Connect with Colleagues"
                  header-bg-variant="dark"
                  header-text-variant="white"
                >
                  <b-card-text style="font-size: 17px;"
                    >Engage in real-time discussions with other healthcare
                    professionals, whether it's for case discussions,
                    consultations, or quick clarifications." Shared Patient
                    Profiles</b-card-text
                  >
                </b-card>
                <b-card
                  border-variant="dark"
                  header="Unified View of Patient Data"
                  header-bg-variant="dark"
                  header-text-variant="white"
                >
                  <b-card-text
                    >Access shared patient profiles that compile all relevant
                    data, from medical history to recent interactions, ensuring
                    every team member is darkrmed." Document and Image Sharing
                  </b-card-text>
                </b-card>
                <b-card
                  border-variant="dark"
                  header="Effortlessly Share Crucial Data"
                  header-bg-variant="dark"
                  header-text-variant="white"
                >
                  <b-card-text
                    >Share important documents, images, and other files
                    securely, ensuring that all relevant darkrmation is
                    available to every member of the care team." Task Management
                    & Coordination.</b-card-text
                  >
                </b-card>
              </b-card-group>
              <b-card-group deck style="margin-top: 30px;">
                <b-card
                  border-variant="dark"
                  header="Stay on Track with Collaborative Tasks"
                  header-bg-variant="dark"
                  header-text-variant="white"
                >
                  <b-card-text style="font-size: 17px;"
                    >Organize and delegate tasks among the team, ensuring timely
                    interventions and coordinated care delivery</b-card-text
                  >
                </b-card>
                <b-card
                  border-variant="dark"
                  header="Integrated Video Conferencing :"
                  header-bg-variant="dark"
                  header-text-variant="white"
                >
                  <b-card-text
                    >Leverage integrated video conferencing tools for more
                    in-depth discussions, case reviews, or virtual
                    consultations.
                  </b-card-text>
                </b-card>
                <b-card  style="border: none;">
                  <b-card-text ></b-card-text>
                </b-card>
              </b-card-group>
            </div>
          </div>

          <h3
            style="text-align: center; margin-bottom: 40px; margin-top: 60px;"
          >
            The Future of Prescription Management
          </h3>
        </div>

        <div class="mt-6">
          <div>
            <div class="row mt-1">
              <div class="col-md-10 offset-md-1">
                <!-- <p><strong>Healthcare Practitioner Schedules:</strong></p> -->
                <b-card-group deck>
                  <b-card
                    border-variant="dark"
                    header="The Power of Collaborative Care"
                    header-bg-variant="dark"
                    header-text-variant="white"
                    style="font-size: 20px;"
                  >
                    <b-card-text style="font-size: 17px;"
                      >Unified Approach: Ensure that every member of the
                      healthcare team has a consistent understanding of the
                      patient's needs.
                    </b-card-text>
                  </b-card>
                  <b-card
                    border-variant="dark"
                    header="Efficiency"
                    header-bg-variant="dark"
                    header-text-variant="white"
                  >
                    <b-card-text
                      >Speed up decision-making and interventions by
                      collaborating in real-time. Comprehensive Care: Benefit
                      from the expertise of various specialties, leading to
                      holistic patient care.
                    </b-card-text>
                  </b-card>
                  <b-card
                    border-variant="dark"
                    header="Flexibility:"
                    header-bg-variant="dark"
                    header-text-variant="white"
                  >
                    <b-card-text>
                      Collaborate from anywhere, anytime, ensuring uninterrupted
                      patient care. Call to Action.</b-card-text
                    >
                  </b-card>
                </b-card-group>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-5"
          style="display: flex; justify-content: center; align-items: center;"
        >
          <div style="width: 500px; text-align: center;">
            <b-card bg-variant="info" text-variant="white" title="" style="border: 1px solid black">
              <b-card-text style="text-align: center;">
                "Unleash the full potential of interdisciplinary collaboration
                with {{main_data}} Online Collaboration Tools. Register
                now and redefine the way healthcare teams work together!"
              </b-card-text>
              <b-button href="#" variant="dark" style="text-align: center;">
                Register Now
              </b-button>
            </b-card>
          </div>
        </div>
      </div>
      <layout-footer></layout-footer>
    </div>
  </div>
</template>
<script>
import config from "../../services/CommonApi";
import axios from "axios";
export default {
  data() {
    return {
      main_data: "",
      config: config,
    };
  },
  mounted() {
    this.get_practitioner_profile();
  },
  methods: {

    async get_practitioner_profile() {
      var domain = window.location.hostname;

      const formdata = {
        domain: window.location.hostname,
      };
      await axios
        .get(
          "https://app.bhilwarahealthcare.in/api/method/sahaj.domain.get_hospital?domain=" +
          window.location.hostname
        )
        .then((res) => {
          this.showspinner = false;
          if (res.data.status_code == 200) {
            this.main_data = res.data.data[0].brand_name
          }
          if (res.data.status_code == 404) {
            if (window.location.hostname == "bhilwarahealthcare.in") {
            } else if (window.location.hostname == "localhost") {
            } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
            } else {
              window.location.href = String("https://bhilwarahealthcare.in");
            }
          }
          this.$swal.close();
        });
    },

  },
}
</script>
.right_heading {
  font-size: 40px;
  font-weight: bold;
  font-family: sans-serif;
}

.right_content {
  font-size: 16px;
  margin-top: 20px;
  font-family: sans-serif;
}
.right_headline {
  margin-top: 20px;
}
.btn {
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/kneexpert/OnlineCollabrations.vue